import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgModule } from '@angular/core';
//import {ConstantMessages} from '../common/ConstantMessages';
import { ToastrService } from 'ngx-toastr';
import { Constants } from 'src/app/common/Constants';
import { MessageService } from 'src/app/common/message.service';
import { HTTPService } from 'src/app/services/http.service';
import { Subscription } from 'rxjs';
import { FooterService } from 'src/app/footer.service';
declare function unescape(s: string): string;
// declare var $: any;
// $.navigation = $('#header-menu');
@Component({
  selector: 'app-root',
  templateUrl: './fulllayout.component.html',
  providers: [HTTPService, MessageService],
})
export class FullLayoutComponent implements OnInit {
  userDetails: any = {};
  MenuFunctionObj: any = {};
  spinnerVisible: boolean = false;
  constants: any;
  constantMessages: any;
  constErrors: any;
  MenuList: any = [];
  messageType: any;
  showFooter: boolean = true;
  isVisibleHeader: boolean = true;
  private subscription: Subscription;

  constructor(
    private footerService: FooterService,
    private _httpService: HTTPService,
    private _router: Router,
    private messageService: MessageService,
    public toastr: ToastrService
  ) {
    this.constants = new Constants();
    this.subscription = this.footerService.showFooter$.subscribe((show) => {
      this.showFooter = show;
    });
  }
  ngOnInit(): void {
    this.footerService.headerVisibility$.subscribe(
      (visibility) => (this.isVisibleHeader = visibility)
    );
  }
  showSpinner() {
    this.spinnerVisible = true;
  }

  hideSpinner() {
    this.spinnerVisible = false;
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
